import $ from 'jquery';
import Slider from 'blocks/slider/slider';
import Slide from 'portlets/site/showcase/slide/slide';

export default class {
	constructor(options) {
		const defaults = {
			el: '#showcaseSlides',
			dom: {
				container: '#showcaseSlidesContainer',
				slider: '#showcaseSlidesSlider',
				slide: '.js-showcase-slide'
			},
			slider: {
				el: '#showcaseSlidesSlider',
				dom: {
					slide: '.js-showcase-slider-slide',
					control: '.js-showcase-slider-control',
					page: '.js-showcase-slider-page'
				}
			},
			callback: {
				set: false
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.data = this.options.data;
		this.prevent = false;
		this.$el = (this.options.el instanceof $) ? this.options.el : $(this.options.el);
		return this;
	}

	getDom() {
		this.$container = this.$el.find(this.options.dom.container);
		return this;
	}

	build() {
		this.$slider = this.$el.find(this.options.dom.slider);
		this.$slide = this.$el.find(this.options.dom.slide);
		return this;
	}

	setSlideStart() {
		this.prevent = true;
	}

	setSlideEnd() {
		this.prevent = false;
	}

	set(index, force = false) {
		let change = false;
		if (!this.prevent || force) {
			this.slider.setSlide(index, false, force);
			change = true;
		}
		return change;
	}

	render() {
		const self = this;
		if (self.$el.length) {
			self.getDom();
			self.build();

			self.options.slider.callback = {
				start: self.setSlideStart.bind(self),
				end: self.setSlideEnd.bind(self)
			};
			self.options.slider.el = this.$slider;
			self.slider = new Slider(self.options.slider).render();

			self.slide = [];
			self.$slide.each(function (index) {
				const $slide = $(this);
				self.slide[index] = new Slide({el: $slide}).render();
			});
		}
		return self;
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/showcase/slides/slides.js